module.exports = __webpack_public_path__ + "static/media/Administrator.9388bcfe.svg";